import { render, staticRenderFns } from "./Bancos.vue?vue&type=template&id=3c64db7a&"
import script from "./Bancos.vue?vue&type=script&lang=js&"
export * from "./Bancos.vue?vue&type=script&lang=js&"
import style0 from "./Bancos.vue?vue&type=style&index=0&id=3c64db7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports